let webHost= ''
if(process.env.NODE_ENV==='production') {
  console.log(window.location.host)
  if(window.location.host.indexOf('prepare')!='-1') {//不是测试环境
    webHost = 'http://prepare.timesaas.cn'
  }else {
    webHost = 'http://www.timesaas.cn'
  }
}else {
  webHost = 'http://prepare.timesaas.cn'
}
export default webHost


// WEBPACK FOOTER //
// ./src/api/config.js